<template>
  <div class="modal">
    <div class="modal-container">
      <div class="modal-content">
        <div class="modal-close">
          <Button class="p-0 b-none" @click="close">
            <svg
              width="26"
              height="25"
              viewBox="0 0 26 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="13"
                cy="12.5"
                r="12.5"
                fill="#333333"
              />
              <path
                d="M16.7104 6.36062C17.1912 5.87979 17.9708 5.87979 18.4516 6.36062C18.8888 6.79773 18.9285
                7.48174 18.5709 7.96374L18.4516 8.10183L8.60183 17.9516C8.12101 18.4325 7.34144 18.4325 6.86062
                17.9516C6.42351 17.5145 6.38377 16.8305 6.74141 16.3485L6.86062 16.2104L16.7104 6.36062Z"
                fill="white"
              />
              <path
                d="M6.86062 6.36062C7.29773 5.92351 7.98174 5.88377 8.46374 6.24141L8.60183 6.36062L18.4516
                16.2104C18.9325 16.6912 18.9325 17.4708 18.4516 17.9516C18.0145 18.3888 17.3305 18.4285 16.8485
                18.0709L16.7104 17.9516L6.86062 8.10183C6.37979 7.62101 6.37979 6.84144 6.86062 6.36062Z"
                fill="white"
              />
            </svg>
          </Button>
        </div>

        <div class="width-lg">
          <p class="modal-title">
            {{ title }}
          </p>
          <p class="modal-desc">
            {{ description }}
          </p>

          <div class="modal-btn-container">
            <Button class="btn btn-outline-danger btn-block" @click="confirm">
              {{ buttonTitle }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/Button.vue';

export default {
  name: 'Modal',
  components: {
    Button,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonTitle: {
      type: String,
      required: true,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
